<div [ngClass]="{ 'pointer-event-none': loderService?.loading }" #screen>
  <header id="fixed-header" class="fixed-header">
    <a
      (click)="OnSkip()"
      (keydown.enter)="OnSkip()"
      class="skip-to-main-content-link"
      href="javascript:;"
    >
      Skip to content
    </a>
    <dg-header class="fixed-header"></dg-header>
  </header>

  <dg-fontresizer></dg-fontresizer>
  <mat-sidenav-container>
    <mat-sidenav-content>
      <main class="main-container">
        <div class="d-flex main_modue_wraper">
          <div class="main_modue_left">
            <dg-nav-bar
              id="fixed-nav"
              #navBar
              [treeConfig]="treeConfig"
              (onClick)="onNodeSelect($event)"
              (onFavoritesChange)="onFavoritesChange($event)"
              [navBarFooterMenu]="footerData"
              (onFooterItemClick)="onFooterItemClick($event)"
            ></dg-nav-bar>
          </div>
          <div
            class="main_modue_right"
            id="fixed-main"
            [ngClass]="{
              breadCrumbView:
                showBreadCrumbInMainView && navBar.megaMenuHeader()?.length > 0
            }"
          >
            <div class="pb-2 content content-container">
              <div
                #support
                cdkDragLockAxis="y"
                cdkDrag
                (cdkDragEnded)="dragEnded($event)"
                (cdkDragStarted)="dragStarted($event)"
                class="supButton"
                *ngIf="false"
              >
                <dg-fab-speed-dial
                  class="dg-fab-speed-dial"
                  [fabTogglerIcon]="togglerIcon"
                  [fabButtons]="buttonList"
                  [closeListOnItemClick]="closeListOnItemClick"
                  [isTogglerMiniFab]="isTogglerMiniFab"
                  [isSvgToggler]="isSvgToggler"
                  [fabTogglerCloseIcon]="'close'"
                  [togglerMatTooltipConfig]="togglerMatTooltipConfig"
                  [direction]="direction"
                  [externalTogglerAction]="true"
                  (onButtonClick)="buttonClick($event)"
                >
                </dg-fab-speed-dial>
              </div>
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <footer class="space-left dashboard-footer">
    <dg-footer id="fixed-footer"></dg-footer>
  </footer>
</div>
<div [ngClass]="{ loading: loderService?.loading }"></div>
